import { render, staticRenderFns } from "./RenameForm.vue?vue&type=template&id=451a41b7&scoped=true&"
import script from "./RenameForm.vue?vue&type=script&lang=js&"
export * from "./RenameForm.vue?vue&type=script&lang=js&"
import style0 from "./RenameForm.vue?vue&type=style&index=0&id=451a41b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a41b7",
  null
  
)

export default component.exports